import React from 'react';

import classNames from 'classnames';

import { Typography, TypographVariant, TypographyColor } from '../Typography/Typography';
import { Check as CheckIcon } from '../icons/Check/Check';
import { UspsCheckMark } from '../icons/UspsCheckMark/UspsCheckMark';
import styles from './Usp.module.css';

export enum IconVariant {
  Check = 'check',
  Guard = 'guard',
}

export type Props = {
  children?: React.ReactNode;
  className?: string;
  iconClassName?: string;
  iconColor?: string;
  iconVariant?: IconVariant;
  subTitle?: JSX.Element | string;
  typographyColor?: TypographyColor | string;
  uspClassName?: string;
  uspSubtitleClassName?: string;
  variant?: TypographVariant;
};

export const Usp: React.FC<Props> = React.memo(({
  iconClassName,
  iconColor,
  uspClassName,
  uspSubtitleClassName,
  className,
  variant,
  typographyColor,
  children,
  subTitle,
  iconVariant = IconVariant.Check,
}) => {
  return (
    <div className={classNames(styles.usp, className)}>
      {iconVariant === IconVariant.Check && (
        <CheckIcon color={iconColor} className={iconClassName} />
      )}

      {iconVariant === IconVariant.Guard && (
        <UspsCheckMark color={iconColor} className={iconClassName} />
      )}

      <div className={styles.textContainer}>
        <Typography className={uspClassName} variant={variant} style={{ color: typographyColor }}>
          {children}
        </Typography>

        {subTitle && (
          <Typography
            variant='body1'
            component='span'
            className={classNames(styles.subTitle, uspSubtitleClassName)}
          >
            {subTitle}
          </Typography>
        )}
      </div>
    </div>
  );
});

Usp.displayName = 'Usp';
